"use client"

import React from "react"
import Link from "next/link"
import { useI18n } from "@/context/i18n"
import { RegistrationModal } from "@/components/RegistrationModal"

const CTASection = () => {
  const { t } = useI18n()

  return (
    <section className="bg-white pt-32">
      <div className="container mx-auto px-4 md:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-black text-black mb-6" style={{ fontFamily: 'DIN, sans-serif' }}>
          {t('cta_titulo_1')} <span className="bg-[#fb0009] text-white px-2 md:px-3 py-1 md:py-2 inline-block">{t('cta_titulo_resaltado')}</span>
        </h2>
        <p className="text-xl text-black/90 mb-8 max-w-2xl mx-auto">
          {t('cta_parrafo')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="https://wa.me/527122315859?text=Hola%20Grupo%20LET%20%F0%9F%98%80%2C%20Estoy%20en%20su%20sitio%20y%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n.%20Vengo%20de%20su%20p%C3%A1gina%20web."
            className="bg-black text-white px-8 py-4 font-bold text-lg rounded-lg hover:bg-primary transition-colors"
            data-ga-action="cta_click"
            data-ga-category="cta"
            data-ga-label={t('cta_contactar')}
          >
            {t('cta_contactar')}
          </Link>

          <RegistrationModal>
            <button
              className="bg-primary text-white px-8 py-4 font-bold text-lg rounded-lg shadow-lg hover:shadow-xl hover:bg-black hover:-translate-y-1 transform transition-all duration-300 border-2 border-primary"
              aria-haspopup="dialog"
            >
              {t('cta_formulario') || 'Regístrate'}
            </button>
          </RegistrationModal>
        </div>
      </div>
    </section>
  )
}

export default CTASection
